const getUserDbId = (user) => {
  return user.user_id.split("|")[1]
}

const getUserMeasureSystem = (user) => {
  let unitSystem = user && user.user_metadata &&  
    user.user_metadata.organization && 
    user.user_metadata.organization.measureSystem ? user.user_metadata.organization.measureSystem : 'metric'

  return unitSystem
}

const getUserKgOrPoundsOfCo2Unit = (user) => {
  let measureSystem = getUserMeasureSystem(user);
  let co2Unit = measureSystem === 'imperial' ? 'lb' : 'kg'
  return co2Unit
}

module.exports = {
  getUserDbId,
  getUserMeasureSystem,
  getUserKgOrPoundsOfCo2Unit
};



// WEBPACK FOOTER //
// ./src/utils/user/info.js